// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountProcurementCardLog } from './account-procurement-card-log';
import { ApprovalTreeUserGroup } from './approval-tree-user-group';
import { Program } from './program';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountProcurementCard extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get namedesc() {
    if (this.isExpired()) {
      return this.pCardName + ' (EXPIRED) - ' + this.description;
    }

    if (!this.active) {
      return this.pCardName + ' (NOT ACTIVE) - ' + this.description;
    }

    return this.pCardName + ' - ' + this.description;
  }

  isExpired() {
    return this.endDate < new Date();
  }

  isCurrentAndActive() {
    return !this.isExpired() && this.active;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Boolean */
  active!: boolean;
  /** Decimal */
  amt!: number;
  /** String(100) */
  description!: string;
  /** DateTime */
  endDate!: Date;
  /** String(100) */
  pCardName!: string;
  /** String(50) */
  pCardPaymentProfileId!: string;
  /** Binary */
  rowVersion!: any;
  /** DateTime */
  startDate!: Date;
  /** FK accountId */
  account!: Account;
  /** Inv FK accountProcurementCardId */
  accountProcurementCardLogs!: AccountProcurementCardLog[];
  /** Inv FK accountProcurementCardId */
  approvalTreeUserGroups!: ApprovalTreeUserGroup[];
  /** Inv FK accountProcurementCardId */
  programs!: Program[];
}

